var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17.856,
    viewBox: "0 0 20 17.856",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet",
    transform: "translate(-2.215 -3.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M5.36,6.188H19.338a3.341,3.341,0,0,1,.488.036A3.423,3.423,0,0,0,18.652,4a2.593,2.593,0,0,0-2.211-.564L4.945,5.69H4.932A2.874,2.874,0,0,0,3.138,7,3.5,3.5,0,0,1,5.36,6.188Z",
    transform: "translate(-0.264 0)",
    fill: "#809bce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M19.358,9H5.072a2.817,2.817,0,0,0-2.857,2.768v8.3A2.817,2.817,0,0,0,5.072,22.84H19.358a2.817,2.817,0,0,0,2.857-2.768v-8.3A2.817,2.817,0,0,0,19.358,9Zm-2.121,8.3a1.385,1.385,0,1,1,1.429-1.384A1.407,1.407,0,0,1,17.237,17.3Z",
    transform: "translate(0 -1.607)",
    fill: "#809bce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M2.25,14.79v-5A3.289,3.289,0,0,1,4.944,6.486a21.783,21.783,0,0,1,3.533-.334s1.155.8.2.8a.621.621,0,1,0,0,1.231c.929,0,0,1.18,0,1.18L4.937,13.61Z",
    transform: "translate(-0.01 -0.793)",
    fill: "#809bce"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.0d69376aacc1b974be2a89022d339e67.svg";
export { ForwardRef as ReactComponent };